import SectionHub from '@/components/docs/SectionHub';

export default function Docs02AlternativeDataSupplyChainHub() {
  return <SectionHub sectionPath="02-alternative-data/supply-chain" />;
}
